module.exports = __webpack_public_path__ + "media/images/components/base/container/gradient-hero-banner-mobile@3x-3c8cabf8833c264c6db19eef0c912a45.jpg";